import { createSlice } from "@reduxjs/toolkit";

export const initialState: any = {
  courseData: [],
  singleCourseData: null,
  courseSuccessMsg: {
    message: "",
    id: "",
  },
  courseErrorMsg: {
    message: "",
    id: "",
  },
  loading: false,
  pagination: {},

  skillData: [],                
  skillSuccessMsg: {            
    message: "",
    id: "",
  },
  skillErrorMsg: {              
    message: "",
    id: "",
  },
  skillLoading: false, 
  
  keySummaryData: [],
  keySummarySuccessMsg: { message: "", id: "" },
  keySummaryErrorMsg: { message: "", id: "" },
  keySummaryLoading: false,

  syllabusData: [],
  syllabusDetailData: [],
  syllabusSuccessMsg: { message: "", id: "" },
  syllabusErrorMsg: { message: "", id: "" },
  syllabusLoading: false,

  syllabusDetailSuccessMsg: { message: "", id: "" },
  syllabusDetailErrorMsg: { message: "", id: "" },
  syllabusDetailLoading: false,

  weeklySyllabusSuccessMsg: { message: "", id: "" },
  weeklySyllabusErrorMsg: { message: "", id: "" },
  weeklySyllabusLoading: false,

  weekData: [],
  weekLoading: false,
  weekErrorMsg: { message: "", id: "" },
  weekSuccessMsg: { message: "", id: "" },

  dayData: [],
  dayLoading: false,
  dayErrorMsg: { message: "", id: "" },
  daySuccessMsg: { message: "", id: "" },
};

const courseSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    fetchAllCourses(state, action) {
      state.courseData = action.payload.data.courses;
      state.pagination = action.payload.data.pagination;
    },
    fetchSingleCourse(state, action) {
      state.singleCourseData = action.payload.data;
    },
    courseSuccessMsg(state, action) {
      state.courseSuccessMsg.message = action.payload.message;
      state.courseSuccessMsg.id = action.payload.id;
    },
    courseErrorMsg(state, action) {
      state.courseErrorMsg = action.payload;
    },
    setCourseLoader(state, action) {
      state.loading = action.payload;
    },
    setPagination(state, action) {
      state.pagination = action.payload;
    },
     fetchAllSkills(state, action) {
      state.skillData = action.payload; 
    },

    skillSuccessMsg(state, action) {
      state.skillSuccessMsg.message = action.payload.message;
      state.skillSuccessMsg.id = action.payload.id;
    },

    skillErrorMsg(state, action) {
      state.skillErrorMsg = action.payload;
    },

    setSkillLoader(state, action) {
      state.skillLoading = action.payload;
    },
    fetchAllKeySummary(state, action) {
      state.keySummaryData = action.payload;  
    },

    keySummarySuccessMsg(state, action) {
      state.keySummarySuccessMsg.message = action.payload.message;
      state.keySummarySuccessMsg.id = action.payload.id;   
    },

    keySummaryErrorMsg(state, action) {
      state.keySummaryErrorMsg = action.payload;
    },

    setKeySummaryLoader(state, action) {
      state.keySummaryLoading = action.payload;
    },
    fetchAllSyllabus(state, action) {
      state.syllabusData = action.payload; 
    },
    syllabusSuccessMsg(state, action) {
      state.syllabusSuccessMsg.message = action.payload.message;
      state.syllabusSuccessMsg.id = action.payload.id;
    },
    syllabusErrorMsg(state, action) {
      state.syllabusErrorMsg = action.payload;
    },
    setSyllabusLoader(state, action) {
      state.syllabusLoading = action.payload;
    },
    setSyllabusDetailData(state, action) {
      state.syllabusDetailData = action.payload;
    },
    syllabusDetailSuccessMsg(state, action) {
      state.syllabusDetailSuccessMsg.message = action.payload.message;
      state.syllabusDetailSuccessMsg.id = action.payload.id;
    },
    syllabusDetailErrorMsg(state, action) {
      state.syllabusDetailErrorMsg = action.payload;
    },
    setSyllabusDetailLoader(state, action) {
      state.syllabusDetailLoading = action.payload;
    },
    fetchAllWeeks(state, action) {
      state.weekData = action.payload;  
    },
    setWeekLoader(state, action) {
      state.weekLoading = action.payload;
    },
    weekSuccessMsg(state, action) {
      state.weekSuccessMsg.message = action.payload.message;
      state.weekSuccessMsg.id = action.payload.id;
    },
    weekErrorMsg(state, action) {
      state.weekErrorMsg = action.payload;
    },

    fetchAllDays(state, action) {
      state.dayData = action.payload;
    },
    setDayLoader(state, action) {
      state.dayLoading = action.payload;
    },
    daySuccessMsg(state, action) {
      state.daySuccessMsg.message = action.payload.message;
      state.daySuccessMsg.id = action.payload.id;
    },
    dayErrorMsg(state, action) {
      state.dayErrorMsg = action.payload;
    },
    weeklySyllabusSuccessMsg(state, action) {
      state.weeklySyllabusSuccessMsg.message = action.payload.message;
      state.weeklySyllabusSuccessMsg.id = action.payload.id;
    },
    weeklySyllabusErrorMsg(state, action) {
      state.weeklySyllabusErrorMsg = action.payload;
    },
    setWeeklySyllabusLoader(state, action) {
      state.weeklySyllabusLoading = action.payload;
    },
  },
});

export const {
  fetchAllCourses,
  fetchSingleCourse,
  courseSuccessMsg,
  courseErrorMsg,
  setCourseLoader,
  setPagination,
  fetchAllSkills,
  skillSuccessMsg,
  skillErrorMsg,
  setSkillLoader,
  fetchAllKeySummary,
  keySummarySuccessMsg,
  keySummaryErrorMsg,
  setKeySummaryLoader,
  fetchAllSyllabus,
  syllabusSuccessMsg,
  syllabusErrorMsg,
  setSyllabusLoader,
  setSyllabusDetailData,    
  syllabusDetailSuccessMsg,
  syllabusDetailErrorMsg,
  setSyllabusDetailLoader,
  fetchAllWeeks,
  setWeekLoader,
  weekSuccessMsg,
  weekErrorMsg,
  fetchAllDays,
  setDayLoader,
  daySuccessMsg,
  dayErrorMsg,
  weeklySyllabusSuccessMsg,
  weeklySyllabusErrorMsg,
  setWeeklySyllabusLoader,
} = courseSlice.actions;

export default courseSlice.reducer;
